import React from 'react';
import { Container, Typography, Textarea } from '@design-system';
import './CommentSection.scss';

export type CommentSectionProps = {
    comment: string;
    onCommentChange: (comment: string) => void;
    readOnly?: boolean;
};

export const CommentSection: React.FC<CommentSectionProps> = ({ comment, onCommentChange, readOnly = false }) => {
    return (
        <Container className="comment-section bg-white" padding="small">
            <Typography intrinsic="h4" className="pl-small-medium-spacing mb-small-medium-spacing mt-small-spacing">
                Commentaires
            </Typography>

            <Container padding="none">
                <Textarea
                    placeholder="Ajouter un commentaire"
                    value={comment}
                    onValueChange={onCommentChange}
                    className="comment-textarea"
                    disabled={readOnly}
                />
            </Container>
        </Container>
    );
};
